import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js/auto'
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  canvas: any;
  ctx: any;
  constructor() { }

  ngOnInit(): void {
    this.canvas = document.getElementById('donut-submittedForms');
    this.ctx = this.canvas.getContext('2d');
    let myChart = new Chart(this.ctx, {
      type: 'doughnut',
      options: {
        cutout: 40, 
        maintainAspectRatio: false
    },
      data: {
          labels: ["Forms Submitted", "Forms Remaining"],
          datasets: [{
              data: [14, 6],
              backgroundColor: ["#17a2b8", "#dee2e6"],
              borderWidth: 0.1
          }]
      },
      
    })
    ;
  }

  
}
